import FormValidator from '@/js/plugins/formValidator'
import { isAppWebBrowser, loadRecaptchaScript } from '@/js/_common'
import { submitPasskeyLogin } from '@/js/_components/passkey/login'
import { setupPasskeyLogin } from '@/js/_components/passkey/discoverable'

const main = () => {
    if (!document.querySelector('#page-user-login')) return
    const siteKeyMeta = document.querySelector('meta[name="google-recaptcha-site-key"]');
    const siteKey = siteKeyMeta ? siteKeyMeta.getAttribute('content') : null;
    const actionName = 'login';
    if (siteKey) loadRecaptchaScript(siteKey, actionName);

    // パスキーのみでのログイン（メールアドレス欄の自動入力候補・「他の方法でログイン」の「パスキーでログイン」ボタン）
    const loginForm = document.querySelector('#input-form form');
    const loginOther = document.querySelector('[data-login-other]');
    const passkeyLogin = loginForm ? setupPasskeyLogin({
        form: loginForm,
        panel: loginOther?.querySelector('[data-passkey-login]') ?? null,
        optionsUrl: `${loginForm.getAttribute('action')}/passkey/options`,
        loginUrl: `${loginForm.getAttribute('action')}/passkey`,
    }) : null;
    passkeyLogin?.armConditional();

    let submitting = false;
    const formValidator = new FormValidator({
        renderAreaSelector: '#input-form',
        renderErrorCnt: false,
        renderErrorPosition: 'outer',
        // パスワード＋パスキー（登録済みの場合）の2段階ログイン
        submitAction: async (formObj, formValues, event, obj) => {
            event.stopPropagation();
            event.preventDefault();
            if (submitting) return;
            submitting = true;
            const form = obj.config.formObj;
            try {
                await submitPasskeyLogin({
                    form,
                    usernameKey: 'email',
                    optionsUrl: `${form.getAttribute('action')}/options`,
                    loginUrl: form.getAttribute('action'),
                    invalidCredentialsMessage: 'ログインに失敗しました。',
                    siteKey,
                    actionName,
                });
            } finally {
                submitting = false;
                // 2段階目のパスキーのダイアログで中断された自動入力の待ち受けを再開する（ログインできた場合は遷移する）
                passkeyLogin?.armConditional();
            }
        },
    })
    // 他の方法でログイン：Googleはアプリ内ブラウザでは使えないため出さない。パスキーは setupPasskeyLogin が対応ブラウザだけ表示する
    if (loginOther) {
        const google = loginOther.querySelector('[data-login-google]');
        if (google && !isAppWebBrowser()) google.hidden = false;
        loginOther.hidden = !loginOther.querySelector('[data-login-google]:not([hidden]), [data-passkey-login]:not([hidden])');
    }
}

export default main;
